import SingleCampaigns from "../HomeCampaign/SingleCampaigns";

export default function CampaignSingleSection(props) {
  const { projectId, assistantsRecord, assistants, isViewOnly } = props;

  return (
    <SingleCampaigns
      projectId={projectId}
      assistantsRecord={assistantsRecord}
      assistants={assistants}
      isViewOnly={isViewOnly}
    />
  );
}
